import { useEffect, useState } from 'react';
import { ImageModel, ServiceModel } from '../../../data/entities';
import { ServiceService, ImageService } from '../../../services';

interface UseMediaProps {
  serviceId: number;
  onUploadSuccess?: () => void;
}

export function useMedia({ serviceId, onUploadSuccess }: UseMediaProps) {
  const [image, setImage] = useState<ImageModel | null>(null);
  const [isLoading, setLoading] = useState<boolean>(false);

  const fetchImage = async () => {
    try {
      setLoading(true);
      const service = await new ServiceService().get(serviceId);
      if (service?.imageId) {
        setImage(await new ImageService().get(service.imageId));
      } else {
        setImage(null);
      }
    } catch (error) {
      console.error('Error fetching initial image:', error);
    } finally {
      setLoading(false);
    }
  };

  const uploadImage = async (image: ImageModel) => {
    const imageRequest = {
      id: serviceId,
      image,
    };
    await new ServiceService().insertImage(imageRequest);
    if (onUploadSuccess) await onUploadSuccess();
  };

  const removeImage = async () => {
    await new ServiceService().deleteImage(serviceId);
    setImage(null);
    if (onUploadSuccess) await onUploadSuccess();
  };

  useEffect(() => {
    fetchImage();
  }, [serviceId]);

  return {
    image,
    isLoading,
    uploadImage,
    removeImage,
    fetchImage,
  };
}
